import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  standalone: false,
  selector: 'app-security-password-resend',
  templateUrl: './security-password-resend.component.html',
  styleUrls: ['./security-password-resend.component.scss'],
})
export class SecurityPasswordResendComponent implements OnInit {
  @Input() tenantSecurityId: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private compService: CompanyService,
  ) {
  }

  ngOnInit(): void { }

  sendNewPassword() {
    this.compService.regenerateCompanySecuritPassword(this.tenantSecurityId).subscribe({
      next: (res) => {
        console.log(res);
        if (res.isValid) {
          // location.reload();
        }
      },
      error: (err) => {
        console.error('Error regenerating password:', err);
        // Handle error response
      }
    });
    this.modal.dismiss();
  }
}
